import Vue from "vue";
import Vuex from "vuex";
import {
	postAutoGenerate,
	putAutoGenerate,
	deleteTestQuesData,
	getAutoGeneratedQus,
	getAutoGenerate,
	deleteMatchTheFollowingQuestion,
	deleteMCQquestion,
	deleteTest,
} from "../../utils/apiFunctions.js";

Vue.use(Vuex);
const state = () => ({
	showTestConfig: false,
	selectedSection: {},
	showPreviewTest: false,
	sourceSelectFilter: "",
	testConfigData: {
		testID: "",
	},
	questionData: [],
	tests: [],
	autoTopicID: "",
	sectionDetails: [],
	autoTestDetails: {},
	filterdata: {
		// protunprot: "",
		publicAvailability: null,
		question: "",
		section: "",
	},
	filtertest: false,
	sectionData: {
		testName: "",
		noofSections: null,
		autoQuestions: null,
		questiontype_options: [],
		editSecName: false,

		autoCheck: false,
		sections: [
			{
				name: "",
				sectionValidationShow: false,

				typedistributeRandomly: false,
				cardClose: false,
				editSecName: false,

				addTypeDisable: false,
				typeDifficultyLevel: [],
				noOfQuestions: null,
				alldiffoptions: [],
				longdiffoptions: [],
				mcqdiffoptions: [],
				mtfdiffoptions: [],

				types: [],

				sameDifficultyLevel: false,

				typediffrequired: false,
			},
		],
	},
});

const getters = {
	getTests: (state) => state.tests,
	getAutoSelectedTest: (state) => state.autoTestDetails,
	getSelectedSection: (state) => state.selectedSection,
	getTestConfigStatus: (state) => state.showTestConfig,
	getAutoTopicID: (state) => state.autoTopicID,
	getShowTestPreviewStatus: (state) => state.showPreviewTest,
	getQuestionData: (state) => state.questionData,
	getAutoSectionDetails: (state) => state.sectionDetails,
	getAutGenData: (state) => state.sectionData,
	getTestConfigData: (state) => {
		return state.testConfigData;
	},
};
const actions = {
	// get auto gen test
	getAutoTests(state, payload) {
		getAutoGeneratedQus(payload)
			.then((res) => {
				if (res.status == 200) {
					let payload = res.data.data;
					for (let i in payload) {
						payload[i].editoption = false;
					}
					state.commit("saveTests", payload);
				}
			})
			.catch((err) => {
				throw err;
			});
	},
	async postAutoGenerate(state, payload) {
		let data = await payload;
		try {
			const res = await postAutoGenerate(data);
			return res;
		} catch (error) {
			return error;
		}
	},
	// get paerticular test
	async getPerticularAutoTest(state, payload) {
		try {
			const res = await getAutoGenerate(payload);
			if (res.status == 200) {
				state.commit("saveAutoSectionDetails", res.data.data.sectionIDs);
				state.commit("saveSelectedAutoTest", res.data.data);
				state.commit("saveAutoTopicID", res.data.data.topicID);
			}
			return res;
		} catch (err) {
			return err;
		}
	},

	// add auto gen
	editAutoGenTest(state, payload) {
		putAutoGenerate(payload)
			.then((res) => {
				if (res.status == 200) {
					this.testID = res.data.data.testID;
				}
			})
			.catch((err) => {
				throw err;
			});
	},

	async deleteAutoTest(state, payload) {
		try {
			let data = {};
			data.testID = payload.testID;
			const res = await deleteTest(payload);
			if (res.status == 200) {
				state.commit("deleteAutoTest", payload);
			}
			return res;
		} catch (error) {
			return error;
		}
	},
	async delAutoQuestions(state, payload) {
		try {
			const res = await deleteTestQuesData(payload);
			if (res.status == 200) {
				state.commit("delAutoQuestions", payload);
			}
			return res;
		} catch (error) {
			return error;
		}
	},
	// DELETE MCQ QUESTION DATA from test and databank
	async deleteAutoMCQTestAndDataBank(state, payload) {
		let data = {
			sectionID: payload.sectionID,
			testID: payload.testID,
			questionKey: payload.questionKey,
			marks: payload.marks,
			addToDatabank: false,
		};
		try {
			const response = await deleteMCQquestion(data);
			if (response.status == 200) {
				state.commit("delAutoQuestions", payload);
			}
			return response;
		} catch (error) {
			throw new Error(`Delete MCq Failed! status: ${error.status}`);
		}
	},

	// delete mafo from test and databank
	async deleteMatchTestAndDatabank(state, payload) {
		let data = {
			sectionID: payload.sectionID,
			testID: payload.testID,
			questionKey: payload.questionKey,
			marks: payload.marks,
			addToDatabank: false,
		};
		try {
			const response = await deleteMatchTheFollowingQuestion(data);
			if (response.status == 200) {
				state.commit("delAutoQuestions", payload);
			}
			return response;
		} catch (error) {
			throw new Error(`Delete MAFo Failed! status: ${error.status}`);
		}
	},
};
const mutations = {
	addTypes(state, payload) {
		const type = {
			type: "",
			count: "",
			diffLevel: [],
			qbdropdiff: false,
			diffLevelrequired: false,
			questionTagOpen: false,
			questionTags: [],
			questionTagsOption: [],
		};
		const existTypes = state.sectionData.sections[payload].types.map(
			(t) => t.type
		);
		if (
			!existTypes.includes("MCQU") ||
			!existTypes.includes("MAFO") ||
			!existTypes.includes("LONG")
		) {
			state.sectionData.sections[payload].types.push(type);
		}
	},
	deleteSection(state, payload) {
		state.sectionData.sections.splice(payload, 1);
		state.sectionData.noofSections--;
	},
	deleteType(state, payload) {
		for (let i in state.sectionData.sections[payload.sectionIndex]
			.questiontype_options) {
			if (
				state.sectionData.sections[payload.sectionIndex].questiontype_options[i]
					.value ==
				state.sectionData.sections[payload.sectionIndex].types[
					payload.typeIndex
				].type
			) {
				state.sectionData.sections[payload.sectionIndex].questiontype_options[
					i
				].disabled = false;
			}

			if (state.sectionData.sections[payload.sectionIndex].types.length <= 2) {
				state.sectionData.sections[payload.sectionIndex].questiontype_options[
					i
				].disabled = false;
			}

			if (state.sectionData.sections[payload.sectionIndex].types.length <= 3) {
				state.sectionData.sections[payload.sectionIndex].addTypeDisable = false;
			}
		}
		state.sectionData.sections[payload.sectionIndex].types.splice(
			payload.typeIndex,
			1
		);
	},
	saveAutoGenData(state, payload) {
		state.sectionData = payload;
	},
	saveTests(state, payload) {
		state.tests = payload;
	},
	saveshowPreviewTest(state, payload) {
		state.showPreviewTest = payload.preview_status;
	},
	saveShowTestConfig(state, payload) {
		state.testConfigData = { ...payload.config_data };
		state.showTestConfig = payload.config_status;
	},
	saveSelectedSection(state, payload) {
		state.selectedSection = payload;
	},
	saveSelectedSectionQuestion(state, payload) {
		state.questionData = payload;
		for (let qd in state.questionData) {
			for (let i in state.questionData[qd].config) {
				if (
					state.questionData[qd].config[i].SectionID ==
					state.selectedSection.sectionID
				) {
					state.questionData[qd].required =
						state.questionData[qd].config[i].config.required;
					state.questionData[qd].autoCorrection =
						state.questionData[qd].config[i].config.autoCorrection;
				}
			}
		}
	},
	saveAutoSectionDetails(state, payload) {
		state.sectionDetails = payload;
	},
	saveSelectedAutoTest(state, payload) {
		state.autoTestDetails = payload;
	},

	saveAutoTopicID(state, payload) {
		state.autoTopicID = payload;
	},
	saveAutoTest(state, payload) {
		for (let i in state.tests) {
			if (payload.testID == state.tests[i].testID) {
				state.tests[i].name = payload.name;
				state.tests[i].publicAvailability = payload.publicAvailability;
			}
		}
	},
	deleteInactiveTest(state, payload) {
		state.tests = state.tests.filter((data) => data.testID != payload.testID);
	},
	saveAddedQuestion(state, payload) {
		state.questionData.push(payload);
	},
	sourceSelectFilter(state, payload) {
		state.sourceSelectFilter = payload;
	},
	testfilter(state, payload) {
		state.filterdata.publicAvailability = payload.publicAvailability;
		state.filterdata.candidates = payload.candidates;
		state.filterdata.section = payload.section;
	},
	saveFilterStatus(state, payload) {
		state.filtertest = payload;
	},
	saveEditedQuestion(state, payload) {
		for (let i in state.questionData) {
			if (payload.questionKey == state.questionData[i].questionKey) {
				state.questionData.splice(i, 1, payload);
				for (let j in state.questionData[i].config) {
					if (state.questionData[i].config[j].SectionID == payload.sectionID) {
						state.questionData[i].config[j].config.required = payload.required;
						state.questionData[i].config[j].config.autoCorrection =
							payload.autoCorrection;
					}
				}
			}
		}
	},
	delAutoQuestions(state, payload) {
		state.questionData = state.questionData.filter(
			(data) => data.questionKey != payload.questionKey
		);
	},
	deleteAutoTest(state, payload) {
		state.tests = state.tests.filter((data) => data.testID != payload.testID);
	},
};
export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters,
};
